export function isWhitePlacementLegal(pieceType, square, boardGetter) {
  // Accept inputs like 'p' or 'wP'; normalize to single-letter lowercase
  const type = (typeof pieceType === 'string' ? pieceType.slice(-1) : '').toLowerCase();
  if (type === 'k') return true; // king anywhere on ranks 1–4 checked below
  const rank = parseInt(square?.[1], 10);
  if (Number.isNaN(rank)) return false;
  // White half only
  if (rank < 1 || rank > 4) return false;
  // Pawn restriction
  if (type === 'p' && (rank === 1 || rank === 8)) return false;
  // Exactly one white king
  if (type === 'k') {
    const hasKing = !!boardGetter?.('w','k');
    if (hasKing) return false;
  }
  return true;
}

export function extractWhitePiecesFromFen(game) {
  const board = game?.board?.() || [];
  const pieces = [];
  const files = 'abcdefgh';
  for (let r = 0; r < 8; r++) {
    for (let f = 0; f < 8; f++) {
      const cell = board[r][f];
      if (cell && cell.color === 'w') {
        const square = `${files[f]}${8 - r}`;
        pieces.push({ type: cell.type, square });
      }
    }
  }
  return pieces;
}

